import { getSessionData } from '@confluence/session-data';

// eslint-disable-next-line no-restricted-imports
import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';
import type { ResolverContext } from '../resolver-context';

export const getSlackEnabled = async (network: ResolverContext['network'], cloudId: string) => {
	try {
		const resp = await network.cfetch(`/gateway/api/slack/confluence/enabled?cloudId=${cloudId}`);
		const { enabled } = await resp.json();
		return Boolean(enabled);
	} catch (err) {
		return true;
	}
};

export const getSlackConnected = async (network: ResolverContext['network'], cloudId: string) => {
	try {
		const resp = await network.cfetch(`/gateway/api/slack/confluence/${cloudId}/status`, {
			method: 'GET',
		});
		const { connected } = await resp.json();
		return Boolean(connected);
	} catch (err) {
		return false;
	}
};

export const getIntegrations = async (network: ResolverContext['network'], appKeys: string[]) =>
	Promise.all(
		appKeys.map(async (appKey): Promise<{ appKey: string; isInstalled: boolean }> => {
			try {
				const result = await network.cfetch(`/wiki/rest/plugins/1.0/${appKey}`, { method: 'GET' });
				return {
					appKey: result.url.split('/').pop() as string,
					isInstalled: true,
				};
			} catch (err) {
				return {
					appKey: err.response.url.split('/').pop(),
					isInstalled: !(err instanceof network.BadStatusError && err.response.status === 404),
				};
			}
		}),
	);

export const experimentalIntegrationsInstalled: ExperimentalQueries['experimentalIntegrationsInstalled'] =
	async (_, { appKeys }, { network }) => {
		const { cloudId } = await getSessionData();

		const [isSlackEnabled, isSlackConnected, integrations] = await Promise.all([
			getSlackEnabled(network, cloudId),
			getSlackConnected(network, cloudId),
			getIntegrations(network, appKeys ?? []),
		]);

		return {
			isSlackEnabled,
			isSlackConnected,
			integrations,
		};
	};
